export const NOTIFICATION_TYPE_OPTIONS = [
  { value: "0", label: "Padrão" },
  { value: "1", label: "Texto Grande" },
  { value: "2", label: "Com Imagens" },
];
